import styled, { css } from 'styled-components'

export const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  height: 100vh;
  width: 100%;
  min-width: 200px;
  margin: 0 auto;
  border-bottom: 6px solid ${props => props.theme.colors.brand.green};
`;

export const LayoutForm = styled.div`
  align-self: stretch; 
  width: 55%;
  display: flex;
  min-height: 0;
  align-items: center;
  justify-content: flex-start;
  overflow-y: visible;
  overflow-x: hidden;
  padding: 48px 32px;
  background: ${props => props.theme.colors.brand.white};

  @media (max-width: 800px) {
    display: flex;
align-items: stretch;      
  justify-content: center;   
    width: 100%;
    padding: 0;
  }
`

export const ImageSide = styled.aside`
  align-self: stretch;
  height: auto;
  position: relative;
  overflow: hidden;
  background: ${p => p.theme.colors.greyFive};
  width: 85vw;

  @media (max-width: 800px) {
    display: none;      
    flex: 0 0 auto;    
    height: 0;      
  }
`

export const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`